import FilterFormContextProvider from 'components/filters/FilterFormContextProvider';
import ScheduledMessagesTabFilters from './filters/ScheduledMessagesTabFilters';
import { SCHEDULED_MESSAGES_TAB_FILTERS_LOCAL_STORAGE_KEY_PREFIX } from './filters/ScheduledMessagesTabFilters.constants';
import {
  getFormDefaultValues,
  scheduledMessagesTabFiltersSchema,
} from './filters/ScheduledMessagesTabFilters.schema';
import ScheduledMessagesTabHeader from './header/ScheduledMessagesTabHeader';
import ScheduledMessagesTable from './table/ScheduledMessagesTable';

const ScheduledMessagesTab = () => {
  return (
    <FilterFormContextProvider
      defaultValues={getFormDefaultValues()}
      localStorageKeyPrefix={
        SCHEDULED_MESSAGES_TAB_FILTERS_LOCAL_STORAGE_KEY_PREFIX
      }
      schema={scheduledMessagesTabFiltersSchema()}
    >
      <ScheduledMessagesTabHeader>
        <ScheduledMessagesTabFilters />
      </ScheduledMessagesTabHeader>
      <ScheduledMessagesTable />
    </FilterFormContextProvider>
  );
};

export default ScheduledMessagesTab;
